import useErrorMessageHandler from '@/@core/helpers/errorMessageHandler';
import { useCallApi } from '@/@core/services/axiosCall';
import {
  reactive,
  Ref,
  ref,
  toRefs,
  unref
} from '@vue/composition-api';
import { defineStore } from 'pinia';

export const useTimelineStore = defineStore('timeline', () => {
  const state = reactive({
    total: 0,
    timelines: []
  });

  async function getManyTimeline() {
    const { errorMessage, result, error } = await useCallApi({
      method: 'get',
      url: '/timelines'
    });

    if (errorMessage) {
      useErrorMessageHandler(error);

      return null;
    }

    state.timelines = result.timelines;
    state.total = result.count;

    return result;
  }

  async function postTimeline(data: any) {
    const { errorMessage, result, error } = await useCallApi({
      method: 'post',
      url: '/timelines',
      data: unref(data)
    });

    if (errorMessage) {
      useErrorMessageHandler(error);

      return null;
    }

    return result;
  }

  async function putTimeline(data: any) {
    const { errorMessage, result, error } = await useCallApi({
      method: 'put',
      url: '/timelines/' + data.id,
      data: unref(data)
    });

    if (errorMessage) {
      useErrorMessageHandler(error);

      return null;
    }

    return result;
  }

  async function deleteTimeline(data: any) {
    const { errorMessage, result, error } = await useCallApi({
      method: 'delete',
      url: '/timelines/' + data.id
    });

    if (errorMessage) {
      useErrorMessageHandler(error);

      return null;
    }

    return result;
  }
  return {
    ...toRefs(state),
    getManyTimeline,
    postTimeline,
    deleteTimeline,
    putTimeline
  };
});
